"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Tooltip_1 = __importDefault(require("@web/common/Tooltip"));
const Modal_1 = __importDefault(require("@web/common/Modal"));
const InputValidator_1 = __importDefault(require("@web/common/InputValidator"));
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
var LesseeTypeEnum;
(function (LesseeTypeEnum) {
    LesseeTypeEnum["COMPANY"] = "company";
    LesseeTypeEnum["SOLE_PROPRIETOR"] = "sole-proprietor";
    LesseeTypeEnum["PRIVATE_PERSON"] = "private_person";
})(LesseeTypeEnum || (LesseeTypeEnum = {}));
var LesseeTypeClassesEnum;
(function (LesseeTypeClassesEnum) {
    LesseeTypeClassesEnum["COMPANY"] = "selected-lessee-type-company";
    LesseeTypeClassesEnum["SOLE_PROPRIETOR"] = "selected-lessee-type-sole-proprietor";
    LesseeTypeClassesEnum["PRIVATE_PERSON"] = "selected-lessee-type-private-person";
})(LesseeTypeClassesEnum || (LesseeTypeClassesEnum = {}));
(() => {
    const howItWorksModal = document.getElementById('how-it-works-modal-open');
    const inquiryFormWrapper = document.getElementById('inquiry-form-wrapper');
    const inquiryForm = document.getElementById('inquiry-form');
    const inquiryFormSendButton = document.getElementById('inquiry_form_send');
    const formInputs = Array.from(document.querySelectorAll('input[type=text], input[type=email], input[type=tel], textarea'));
    const emailInput = document.getElementById('inquiry_form_email');
    const phoneInput = document.getElementById('inquiry_form_phone');
    const nameInput = document.getElementById('inquiry_form_name');
    const companyNameInput = document.getElementById('inquiry_form_companyName');
    const companyNameLabel = document.querySelector('label[for="inquiry_form_companyName"]');
    const lesseeTypeInputs = Array.from(document.querySelectorAll('input[name="inquiry_form[lesseeType]"]'));
    const selectedLesseeType = document.querySelector('input[name="inquiry_form[lesseeType]"]:checked');
    function isFormValid() {
        if (inquiryFormSendButton === null || emailInput === null || phoneInput === null
            || nameInput === null || companyNameInput === null || inquiryForm === null) {
            return false;
        }
        const isCompanyLesseeType = inquiryForm.classList.contains(LesseeTypeClassesEnum.COMPANY);
        return (InputValidator_1.default.isEmailValid(emailInput.value) && InputValidator_1.default.isPhoneValid(phoneInput.value)
            && InputValidator_1.default.isTextValid(nameInput.value)
            && (isCompanyLesseeType ? InputValidator_1.default.isTextValid(companyNameInput.value) : true));
    }
    function setCompanyRequiredAttribute(isRequired) {
        if (companyNameInput === null) {
            return;
        }
        if (isRequired === false) {
            companyNameInput.removeAttribute('required');
        }
        else {
            companyNameInput.setAttribute('required', 'required');
        }
        if (companyNameLabel === null) {
            return;
        }
        if (isRequired === false) {
            companyNameLabel.classList.remove('required');
        }
        else {
            companyNameLabel.classList.add('required');
        }
    }
    function selectLesseeType(value) {
        if (inquiryForm === null) {
            return;
        }
        inquiryForm.classList.remove(LesseeTypeClassesEnum.COMPANY, LesseeTypeClassesEnum.SOLE_PROPRIETOR, LesseeTypeClassesEnum.PRIVATE_PERSON);
        switch (value) {
            case LesseeTypeEnum.COMPANY: {
                inquiryForm.classList.add(LesseeTypeClassesEnum.COMPANY);
                setCompanyRequiredAttribute(true);
                break;
            }
            case LesseeTypeEnum.SOLE_PROPRIETOR: {
                inquiryForm.classList.add(LesseeTypeClassesEnum.SOLE_PROPRIETOR);
                setCompanyRequiredAttribute(false);
                break;
            }
            case LesseeTypeEnum.PRIVATE_PERSON: {
                inquiryForm.classList.add(LesseeTypeClassesEnum.PRIVATE_PERSON);
                setCompanyRequiredAttribute(false);
                break;
            }
            default:
                console.error('Unknown lessee type value');
        }
    }
    function pushDatalayerEvent(event, eventLabel) {
        (0, GtmDataLayer_1.default)({
            event,
            eventLabel,
        });
    }
    if (howItWorksModal) {
        (() => new Modal_1.default(howItWorksModal))();
        howItWorksModal.addEventListener('click', () => {
            pushDatalayerEvent('inquiry_how_it_works_modal_open');
        });
    }
    if (inquiryFormWrapper) {
        const tooltip = inquiryFormWrapper.querySelector('.tooltip');
        if (tooltip) {
            (() => new Tooltip_1.default(tooltip))();
        }
    }
    if (inquiryForm === null || inquiryFormSendButton === null || companyNameInput === null
        || nameInput === null || phoneInput === null || emailInput === null) {
        return;
    }
    if (selectedLesseeType) {
        selectLesseeType(selectedLesseeType.value);
    }
    lesseeTypeInputs.forEach((input) => {
        input.addEventListener('change', () => {
            selectLesseeType(input.value);
        });
    });
    formInputs.forEach((input) => {
        input.addEventListener('focus', () => {
            pushDatalayerEvent('inquiry_field_focus', input.getAttribute('id') || null);
        });
    });
    inquiryForm.addEventListener('submit', (event) => {
        if (isFormValid() === false) {
            event.preventDefault();
            return;
        }
        inquiryFormSendButton.setAttribute('disabled', 'true');
        inquiryFormSendButton.innerText = 'Odesílám...';
    });
    companyNameInput.addEventListener('blur', () => {
        InputValidator_1.default.validateTextInput(companyNameInput, 'Vyplňte prosím název firmy.');
    });
    nameInput.addEventListener('blur', () => {
        InputValidator_1.default.validateTextInput(nameInput, 'Vyplňte prosím jméno a příjmení.');
    });
    phoneInput.addEventListener('blur', () => {
        InputValidator_1.default.validatePhoneInput(phoneInput);
    });
    emailInput.addEventListener('blur', () => {
        InputValidator_1.default.validateEmailInput(emailInput);
    });
})();
